export function parseCopyCountInput(rawValue: string, maxCopies: number): number | null {
  const value = rawValue.trim();
  if (!/^\d+$/.test(value)) return null;

  const copies = Number(value);
  if (!Number.isSafeInteger(copies) || copies < 1 || copies > maxCopies) return null;
  return copies;
}
